import script from "./AuthModalSlot.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthModalSlot.vue?vue&type=script&setup=true&lang=js"

import "./AuthModalSlot.vue?vue&type=style&index=0&id=74722779&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74722779"]])

export default __exports__